// src/components/RequirementsList.js
import React from 'react';
import { Trash2, CheckCircle } from 'lucide-react';

const RequirementsList = ({ requirements, onOpenDeleteModal }) => {
  return (
    <div className="bg-gray-50 rounded-lg overflow-hidden border border-gray-200">
      <table className="min-w-full leading-normal">
        <thead>
          <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
            <th className="py-3 px-6 text-left">Name</th>
            <th className="py-3 px-6 text-left">Type</th>
            <th className="py-3 px-6 text-left">Qty & Unit</th>
            <th className="py-3 px-6 text-left">Total Cost</th>
            <th className="py-3 px-6 text-left">Budget Code</th>
            <th className="py-3 px-6 text-left">Specifications</th>
            <th className="py-3 px-6 text-left">Status</th>
            <th className="py-3 px-6 text-center">Actions</th>
          </tr>
        </thead>
        <tbody className="text-gray-600 text-sm font-light">
          {requirements.length === 0 ? (
            <tr>
              <td colSpan="8" className="py-4 text-center text-gray-500">No requirements added yet.</td>
            </tr>
          ) : (
            requirements.map(req => (
              <tr key={req._id} className="border-b border-gray-200 hover:bg-gray-100">
                <td className="py-3 px-6 text-left whitespace-nowrap">{req.name}</td>
                <td className="py-3 px-6 text-left">{req.type}</td>
                <td className="py-3 px-6 text-left">{req.quantity} {req.unit}</td>
                <td className="py-3 px-6 text-left">${req.totalCost.toLocaleString()}</td>
                <td className="py-3 px-6 text-left">{req.budgetCode}</td>
                <td className="py-3 px-6 text-left">
                  {req.specification && req.specification.trim() !== '' ? req.specification : 'N/A'}
                </td>
                <td className="py-3 px-6 text-left">
                  <span className={`py-1 px-3 rounded-full text-xs font-semibold ${
                    req.status === 'Issued' ? 'bg-green-200 text-green-800' :
                    req.status === 'Cancelled' ? 'bg-red-200 text-red-800' :
                    'bg-yellow-200 text-yellow-800'
                  }`}>
                    {req.status}
                  </span>
                </td>
                <td className="py-3 px-6 text-center">
                  {req.status === 'Issued' ? (
                    <CheckCircle size={18} className="text-green-500 mx-auto" title="Requirement met" />
                  ) : (
                    <button
                      onClick={() => onOpenDeleteModal(req)}
                      className="text-red-600 hover:text-red-800 transition-colors duration-200"
                      title="Delete Requirement"
                    >
                      <Trash2 size={18} />
                    </button>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default RequirementsList;
